import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            sx={{
                mt: 8,
                py: 6,
                px: 4,
                textAlign: 'center',
                background: '#c1c5c6', // Degradado ajustado a la paleta
                borderRadius: '16px',
                color: '#20232A', // Color de texto general del contenedor
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Sombra suave
            }}
        >
            <Grid item xs={12}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        mb: 2,
                    }}
                >
                    ¡Prepárate para el{' '}
                    <span style={{ color: '#718895' }}>éxito</span>!
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        mb: 4,
                        color: '#4D5C61', // Color de texto secundario
                    }}
                >
                    Descubre los diplomados diseñados para impulsar tu carrera y alcanzar tus metas profesionales.
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        px: { xs: 3, md: 4 }, // Padding horizontal responsivo
                        py: { xs: 1, md: 1.5 }, // Padding vertical responsivo
                        fontSize: { xs: '0.9rem', md: '1rem' }, // Tamaño de fuente responsivo
                        fontWeight: 600,
                        color: '#fff', // Color de texto
                        backgroundColor: 'rgb(51, 64, 64)', // Color de fondo
                        borderRadius: '10px', // Bordes redondeados
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Sombra del botón
                        transition: 'all 0.3s ease', // Transición suave
                        '&:hover': {
                            backgroundColor: 'rgb(41, 54, 54)', // Fondo al hacer hover
                            transform: 'scale(1.05)', // Escala al hacer hover
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)', // Sombra al hacer hover
                        },
                    }}
                    onClick={() => navigate('/About')}
                >
                    Ver Diplomados
                </Button>
            </Grid>
        </Grid>
    );
};

export default CallToAction;
